<div class="prs-global-header" [class.active-subscription]="!!user?.active_subscription">
  @if (contentService.uploadSession.totalProgress) {
    <div class="file-upload-progress" [ngStyle]="{ width: 'calc(' + contentService.uploadSession.totalProgress + '% + 15px)' }"></div>
  }
  <div class="header-container">
    @if (contentService.uploadSession.totalFilesUploading) {
      <div class="logo-container">
        <div>
          <!-- <img [src]="appService.presonusAdminLogo" class="pointer text-logo" /> -->
          <span class="uploading-header-details">
            {{ "general.uploading" | translate }} {{ contentService.uploadSession.totalFilesUploading }} File{{ contentService.uploadSession.totalFilesUploading == 1 ? "" : "s" }}
            <span style="font-size: 12px; color: #eaeaea; display: block">
              {{ contentService.uploadSession.totalProgress }}% -
              <a (click)="downloadDetails()" class="c-lblue pointer">Details</a>
            </span>
          </span>
        </div>
      </div>
    }
    @if (!contentService.uploadSession.totalFilesUploading) {
      <a class="logo-container" [routerLink]="['/home']">
        <img [src]="appService.presonusAdminLogo" class="pointer text-logo" />
      </a>
    }

    <div class="text-left options">
      <a [routerLink]="['/products/']" class="nav-option">Products</a>
      <!--
      For now, we will manage subscription products the Products section.
      <a [routerLink]="['/subscriptions/']" class="nav-option">Subscriptions</a>
      -->
      <a [routerLink]="['/studiooneplus/']" class="nav-option">Fender Studio Pro+</a>
      <a [routerLink]="['/customer/']" class="nav-option">Customer</a>
      <a [routerLink]="['/content/']" class="nav-option">Content</a>
      <a [routerLink]="['/ai-assistant/']" class="nav-option">AI Features</a>
    </div>

    <div class="account">
      <div class="d-flex align-items-center justify-content-end">
        <div class="d-flex align-items-center pointer position-relative">
          <img (click)="profilePhotoClicked(communityService.connectionRequests?.length ? 'connections' : 'about')" [src]="userService.profilePicture" class="profile-photo m-r-10" />
          @if (communityService.connectionRequests?.length) {
            <span
              class="connection-requests-badge"
              (click)="profilePhotoClicked(communityService.connectionRequests?.length ? 'connections' : 'about')"
              [ngbTooltip]="'com.connection_requests_count' | translate: { count: communityService.connectionRequests.length }"
            >
              {{ communityService.connectionRequests.length }}
            </span>
          }
          <button
            type="button"
            id="header-menu-button"
            class="btn bg-transparent header-btn p-0 border-0"
            (click)="hamburgerClick()"
            (keydown.space)="$event.preventDefault(); hamburgerClick()"
            [attr.aria-expanded]="appService.showNavOverlay"
            aria-controls="cloud-nav-overlay"
            [attr.aria-label]="'general.menu' | translate"
          >
            <fa-icon class="c-white circle-icon-btn hamburger-menu-icon" data-cy="header-options" [icon]="appService.showNavOverlay ? 'times' : 'bars'" aria-hidden="true"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
@if (showNotifications) {
  <myp-notifications-overlay (closed)="showNotifications = false"></myp-notifications-overlay>
}
